import React from 'react';
import 'moment/locale/es-us';

import { LinkContainer } from 'react-router-bootstrap';

import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import StarRatings from 'react-star-ratings';

const CourseSummary = ({ course }) => {
  return (
    <div>
      {course ? (
        <Card style={{ borderRadius: 15 }} className='shadow-sm mx-2 all-cards my-3'>
          <Card.Img
            variant='top'
            src={course.courseImageUrl || ''}
            alt={course.courseName}
            className='card-header-rounded image-background-color'
            height='151'
          />
          <Card.Body>
            <Card.Title className='course-card-title'>{course.courseName}</Card.Title>
            <Card.Text className='crop-text-3'>{course.courseIntro}</Card.Text>
            <div>
              <StarRatings
                rating={course.courseRating}
                starRatedColor='#ffc107'
                numberOfStars={5}
                starDimension='20px'
                starSpacing='1px'
                name='rating'
                className='d-inline'
              />
              <div className='ml-2 rating-position d-inline'>{course.courseRating}</div>
            </div>
          </Card.Body>
          <Card.Footer className='card-footer-rounded'>
            <LinkContainer to={'/course/' + course.id}>
              <Button variant='' block className='mr-3 card-primary-button'>
                Solicítalo Aquí
              </Button>
            </LinkContainer>
          </Card.Footer>
        </Card>
      ) : (
        <Card style={{ borderRadius: 15 }} className='shadow-sm mx-2 my-3'>
          <div className='m-0 p-0 image-skeleton animated'></div>
          <Card.Body>
            <Card.Title className='course-card-title'>
              <div className='text-full-width-skeleton animated'></div>
            </Card.Title>
            <Card.Text className='crop-text-3'>
              <div className='my-1 text-full-width-skeleton animated'></div>
              <div className='my-1 text-full-width-skeleton animated'></div>
              <div className='my-1 text-almost-full-width-skeleton animated'></div>
            </Card.Text>
            <div className='text-half-width-skeleton animated'></div>
          </Card.Body>
          <Card.Footer className='card-footer-rounded'>
            <div className='button-skeleton animated'></div>
          </Card.Footer>
        </Card>
      )}
    </div>
  );
};

export default CourseSummary;
